import { StatsWrapper } from "./style";
import { PageSkeletonLoader } from "@/common/components/skeleton/page-skeleton";
import { LargeCard } from "./LargeCard";
import { chartIcon } from "@/common/components/icons/svg-icons";
import styled from "styled-components";
import Table from "@/common/components/Table";

const StyledStatsWrapper = styled(StatsWrapper)`
  .main-header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .header-title {
    font-size: 1.1rem;
    font-weight: 700;
    color: ${({ theme }) => theme.text.prim_100};
    text-align: left;
  }
`;

export interface IStatsProps {}

export function StateMinistryStats(_: IStatsProps) {
  const loading = false;

  if (loading) return <PageSkeletonLoader />;

  return (
    <StyledStatsWrapper>
      <div className="main-header">
        <h2 className="header-title">Dashboard Overview</h2>
      </div>

      <div className="total-cards">
        <LargeCard
          icon={chartIcon}
          description=""
          value={10}
          title="Total DRF Users"
          color="#28105B"
        />
        <LargeCard
          icon={chartIcon}
          description={``}
          value={500000}
          title="Revenue Fund Allocation"
          color="#13A7F6"
        />
        <LargeCard
          icon={chartIcon}
          value={100000}
          description={``}
          title="Total Funds Released"
          color="#4EE437"
        />
        <LargeCard
          icon={chartIcon}
          value={1000000}
          description={``}
          title="Current DRF Balance"
          color="#0B7F68"
        />
      </div>

      <div className="product-stat-wrapper">
        <h2 className="delivery-title">DRF Facilities</h2>

        <Table
          tableHeaders={[
            "Facility Name",
            "Current Balance",
            "Last Allocation Date",
            "DRF Request Status",
            "Action",
          ]}
          tableKeys={[
            "facilityName",
            "currentBalance",
            "lastAllocationDate",
            "drfRequestStatus",
            "action",
          ]}
          tableData={[
            {
              facilityName: "Facility 1",
              currentBalance: "100000",
              lastAllocationDate: "2021-01-01",
              drfRequestStatus: "Pending",
              action: "View",
            },
          ]}
          rowLineColor="light"
        />
      </div>
    </StyledStatsWrapper>
  );
}
